export default "__VITE_ASSET__5TepRdcK__"